// strona koszyka

import React, { FC, useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import classnames from 'classnames';
import { useLocation } from 'react-router-dom';

import { HtmlBlock } from 'components/containers/HtmlBlock';
import { Container } from 'components/controls';

import styles from 'theme/pages/Cart/Cart.module.scss';

// typ danych wejściowych
interface IProps {
  sectionId?: string;
  articleId?: string;
  h1?: string | null;
  hasSeoTitle?: boolean;
}

const CmsPage: FC<IProps> = ({ sectionId, articleId, h1, hasSeoTitle}) => {
  const { pathname } = useLocation();

  // ID aktualnego artykułu
  const { sectionId: paramsSectionId, articleId: paramsArticleId } = useParams();

  // funkcja skrolująca stronę do góry
  const scrollToTop = useCallback(() => document.documentElement.scrollTo({ top: 0, left: 0 }), []);

  // przeskrolowanie strony do góry przy przejściu między stronami
  useEffect(() => {
    scrollToTop();
  }, [pathname]);

  return (
    <div className={classnames(styles.componentWrapper, 'StylePath-Pages-CmsPage')}>
      <Container fullWidth>
        {(sectionId || paramsSectionId) && (
          <HtmlBlock
            sectionId={sectionId || paramsSectionId || ''}
            articleId={articleId || paramsArticleId}
            withBreadCrumbs
            isCmsPage
            h1={h1}
            hasSeoTitle={hasSeoTitle}
          />
        )}
      </Container>
    </div>
  );
};

export default CmsPage;
